import { render, staticRenderFns } from "./Juveniles.vue?vue&type=template&id=22dcc6c0&scoped=true&"
import script from "./Juveniles.vue?vue&type=script&lang=js&"
export * from "./Juveniles.vue?vue&type=script&lang=js&"
import style0 from "./Juveniles.vue?vue&type=style&index=0&id=22dcc6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcc6c0",
  null
  
)

export default component.exports